exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content-804e5675{padding:20px;border-radius:10px}.formField-3a9ad406{margin:20px}.fieldName-78df83ed{margin-right:10px}.submitButton-bb93fcb7{margin-top:10px}.closeButton-048d55db{position:absolute;top:20px;right:20px;opacity:0.8;cursor:pointer}.closeButton-048d55db:hover{opacity:1}\n", ""]);

// Exports
exports.locals = {
	"content": "content-804e5675",
	"formField": "formField-3a9ad406",
	"fieldName": "fieldName-78df83ed",
	"submitButton": "submitButton-bb93fcb7",
	"closeButton": "closeButton-048d55db"
};